import { bayonneConfig } from "./data";
import CityPageTemplate from "@/pages/city-template/CityPageTemplate";

export default function BayonnePage() {
  return <CityPageTemplate config={bayonneConfig} />;
}